import React from 'react';
import Marquee from '../shared/Marquee';

/**
 * Slim infinite-scroll band of framework names. Sits between hero and problem
 * as a low-commitment "we cover everything" signal. Two counter-scrolling rows
 * for extra motion depth.
 */
const FRAMEWORKS_TOP = [
  'CSRD / ESRS', 'AASB S2', 'IFRS S2', 'TCFD', 'GRI', 'ISSB',
  'EU Taxonomy', 'SASB', 'CDP', 'SBTi', 'BRSR', 'SFDR',
];
const FRAMEWORKS_BOTTOM = [
  'GHG Protocol', 'ISO 14064', 'ISO 14001', 'PCAF', 'TNFD',
  'ISSB S1', 'CDSB', 'IIRC', 'ISAE 3410', 'ISAE 3000', 'PAS 2060',
];

const Chip = ({ label, accent }) => (
  <div
    className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white/80 px-5 py-2 text-sm font-semibold text-slate-700 backdrop-blur-sm shadow-sm"
  >
    <span
      className="inline-block h-2 w-2 rounded-full"
      style={{ background: accent }}
    />
    {label}
  </div>
);

const ACCENTS = ['#3b82f6', '#10b981', '#06b6d4', '#8b5cf6', '#f59e0b', '#ec4899'];

const FrameworksMarquee = () => {
  return (
    <section className="py-16 md:py-20 bg-gradient-to-b from-white via-slate-50/60 to-white overflow-hidden">
      <div className="max-w-6xl mx-auto px-6 mb-8 text-center">
        <div className="text-xs font-bold uppercase tracking-[0.28em] text-blue-600 mb-2">
          Every framework in the room
        </div>
        <h3 className="text-2xl md:text-3xl font-bold text-slate-900">
          One workspace.{' '}
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-emerald-500">
            Every standard your board asks about.
          </span>
        </h3>
      </div>

      <Marquee speed={38} direction="left" pauseOnHover fadeEdges>
        {FRAMEWORKS_TOP.map((f, i) => (
          <Chip key={f} label={f} accent={ACCENTS[i % ACCENTS.length]} />
        ))}
      </Marquee>

      <div className="h-4" />

      <Marquee speed={44} direction="right" pauseOnHover fadeEdges>
        {FRAMEWORKS_BOTTOM.map((f, i) => (
          <Chip key={f} label={f} accent={ACCENTS[(i + 2) % ACCENTS.length]} />
        ))}
      </Marquee>
    </section>
  );
};

export default FrameworksMarquee;
